import {
    Pie,
    PieChart,
    Tooltip,
    Legend,
    Cell,
    ResponsiveContainer,
} from "recharts";

export default function PieChartEstados({
    data,
    isAnimationActive = true,
    onSliceClick,
}) {
    const safeData = Array.isArray(data) ? data : [];

    const renderTooltip = ({ payload }) => {
        if (!payload || !payload.length) return null;
        const item = payload[0]?.payload ?? payload[0];
        return (
            <div className="bg-white border border-neutral-200 rounded-lg shadow-lg px-3 py-2 text-sm">
                <div className="font-medium">{item?.name ?? ""}</div>
                <div className="text-neutral-600">Cantidad: {item?.value ?? 0}</div>
                {onSliceClick && (
                    <div className="text-xs text-blue-600 mt-1">Clic para ver detalle</div>
                )}
            </div>
        );
    };

    return (
        <ResponsiveContainer width="100%" height="100%">
            <PieChart>
                <Tooltip content={renderTooltip} />
                <Legend
                    formatter={(value, entry) => {
                        const count = entry?.payload?.value ?? entry?.payload?.payload?.value;
                        return (
                            <span style={{ color: entry?.color ?? "#333" }}>
                                {value}
                                {count != null && (
                                    <span className="text-neutral-500"> ({count})</span>
                                )}
                            </span>
                        );
                    }}
                />
                <Pie
                    data={safeData}
                    dataKey="value"
                    nameKey="name"
                    innerRadius="60%"
                    outerRadius="100%"
                    cornerRadius={4}
                    paddingAngle={3}
                    isAnimationActive={isAnimationActive}
                    onClick={onSliceClick ? (data) => onSliceClick(data) : undefined}
                    cursor={onSliceClick ? "pointer" : "default"}
                >
                    {safeData.map((entry, index) => (
                        <Cell
                            key={`cell-${index}`}
                            fill={entry.fill ?? `hsl(${(index * 360) / safeData.length}, 70%, 50%)`}
                            strokeWidth={1}
                            stroke="#fff"
                        />
                    ))}
                </Pie>
            </PieChart>
        </ResponsiveContainer>
    );
}
